import { reactive } from 'vue';
import { Routes } from '@/models/router/router.interface';
import { IState } from '@/models/store/state.interface';
import { ModalDashboardPreviewState, ModalErrorState } from '@/models/modal.interface';
import { LoadingState } from '@/models/loading.interface';
import DataTracker from '@/infrastructure/data-tracker';

const state: any = reactive({
	availableDashboards: [],
	loadingStateDashboards: LoadingState.ACTIVE,
	modalDashboardPreviewState: ModalDashboardPreviewState.INACTIVE,
	modalErrorState: ModalErrorState.INACTIVE,
	router: {
		current: Routes.OVERVIEW,
		next: null,
		props: {
			id: ''
		}
	},
	standAloneLogin: false,
	tableauJWT: '',
	tracker: new DataTracker()
});

export default state as IState;
